let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b01pn")).then(() => parcelRequire('js5pv'));